import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ArrowLeft = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10.9H9.4L12.7 7.6C13.1 7.2 13.1 6.6 12.7 6.2C12.3 5.8 11.7 5.8 11.3 6.2L6.3 11.2C5.9 11.6 5.9 12.2 6.3 12.6L11.3 17.6C11.7 18 12.3 18 12.7 17.6C13.1 17.2 13.1 16.6 12.7 16.2L9.4 12.9H17C17.6 12.9 18 12.5 18 11.9C18 11.4 17.6 10.9 17 10.9Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowLeft
